"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveStyle = void 0;

var _seamlessImmutable = require("seamless-immutable");

var retrieveStyle = function retrieveStyle(theme) {
  return {
    textarea: {
      background: (0, _seamlessImmutable.getIn)(theme, ['UTTextArea', 'textarea', 'background'])
    }
  };
};

exports.retrieveStyle = retrieveStyle;